import { FunctionComponent, h } from 'preact';
import { Text } from 'preact-i18n';
import { NBSP, PaxAmount, Properties } from '../../../common';
import { isNotPresent } from '../../../utils';

export enum PaxAmountType {
  DETAILED,
  SUM,
  NUMBER,
}

type PaxGroup = { key: string; amount: number };

export interface PaxAmountDetailsProps extends Omit<Properties, 'type'> {
  paxAmount: PaxAmount;
  type: PaxAmountType;
}

export const PaxAmountDetails: FunctionComponent<PaxAmountDetailsProps> = ({
  type,
  paxAmount,
}: PaxAmountDetailsProps) => {
  if (isNotPresent(paxAmount)) {
    return null;
  }

  const { adults = 0, c15s = 0, children = 0, infants = 0 } = paxAmount;
  const groups: PaxGroup[] = [
    { key: 'adults', amount: adults },
    { key: 'children', amount: children + c15s },
    { key: 'infants', amount: infants },
  ].filter(({ amount }: PaxGroup) => amount > 0);
  const passengerCount: number = groups.reduce((acc: number, { amount }: PaxGroup) => acc + amount, 0);

  return (
    <div class="overflow-hidden truncate">
      {type === PaxAmountType.DETAILED &&
        groups.map(({ key, amount }: PaxGroup, i: number) => [
          i > 0 && ', ',
          `${amount}${NBSP}`,
          <Text key={key} id={`paxAmount.${key}`} plural={amount} />,
        ])}
      {type === PaxAmountType.SUM && (
        <Text id="paxAmountDetails.sum" plural={passengerCount} fields={{ passengerCount }} />
      )}
      {type === PaxAmountType.NUMBER && passengerCount}
    </div>
  );
};
